// Section 17 live projection strip above the list: expected food next season, expected strength
// of the farming group, expected deaths this season, projected trust change and inequality.
// Greyed while a new projection is being computed (24.8). Props only.
import type { ShortageStrip } from '../../viewModels/shortage';
import { shortageText } from '../text/en';

interface Props {
  strip: ShortageStrip | null;
  stale: boolean;
}

export function ProjectionStrip({ strip, stale }: Props) {
  const dash = '—';
  const farmers =
    strip === null || strip.farmerStrength === null || strip.farmerStrengthNow === null
      ? dash
      : shortageText.farmers(
          Math.round(strip.farmerStrengthNow).toString(),
          Math.round(strip.farmerStrength).toString(),
        );
  return (
    <section
      class={`shortage__strip${stale ? ' is-stale' : ''}`}
      aria-labelledby="shortage-strip-title"
      aria-busy={stale}
    >
      <h3 id="shortage-strip-title" class="shortage__strip-title">
        {shortageText.stripHeading}
        {stale && <span class="hint"> {shortageText.recomputing}</span>}
      </h3>
      <dl class="shortage__figures">
        <div>
          <dt>{shortageText.stripFood}</dt>
          <dd class="num">
            {strip === null || strip.foodNextSeason === null
              ? dash
              : shortageText.food(strip.foodNextSeason, strip.foodProducedNextSeason)}
          </dd>
        </div>
        <div>
          <dt>{shortageText.stripFarmers}</dt>
          <dd class="num">{farmers}</dd>
        </div>
        <div>
          <dt>{shortageText.stripDeaths}</dt>
          <dd class="num">{strip === null ? dash : shortageText.deaths(strip.expectedDeaths)}</dd>
        </div>
        <div>
          <dt>{shortageText.stripTrust}</dt>
          <dd class="num">{strip === null ? dash : shortageText.trust(strip.trustChange)}</dd>
        </div>
        <div>
          <dt>{shortageText.stripInequality}</dt>
          <dd class="num">{strip === null ? dash : shortageText.inequality(strip.inequality)}</dd>
        </div>
      </dl>
    </section>
  );
}
